module.exports = __webpack_public_path__ + "img/1.a4939178.jpg";